import { useQuery } from "../../Utils/utils"

export const useAlertsPageQuery = (search) => {
  const query = useQuery(search)
  return {
    openAlertID: query.get("open_alert"),
    business_account_id: query.get("business_account_id")
  }
}
